export const API_VERSION = '15.0.0';
export const BASE_PATH = '/portal';
export const USER_GUIDE_PATH = '/user-guide';
